import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryDocumentItemPriceCannotBeLessThanZero extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.item.validation.price.cannot-be-less-than-zero');
    }
}
